import store from '@/store'
import urlUtil from '@/utils/urlUtil'
import router from '@/router'
import { getUserInfoByCode, getUserInfoById } from '@/api/authentication'
import { setId, getId, setUserName, setAvatar } from '@/utils/auth'

function getPermission () {
  // 用户登录的情况下
  if (getId()) {
    return getUserInfoById(getId()).then(res => {
      store.commit('SET_NAME', res.data && res.data.nickName)
      store.commit('SET_USERID', res.data && res.data.id)
      store.commit('SET_AVATAR_URL', res.data && res.data.avatarUrl)
      store.commit('SET_LOGIN_STATE', true)
    })
  } else {
    // 用户没有登录
    if (urlUtil.getQueryString('code')) {
      // 扫描过二维码， 微信返回一个code， 拿code取用户信息
      // 这里把这个token传到后台去，去获取用户信息，把用户信息存在vuex全局变量中
      // 页面显示成登录状态
      store.commit('SET_BARCODESHOW', false)
      return getUserInfoByCode(urlUtil.getQueryString('code')).then(res => {
        let newUrl = window.location.href.split('?')[0]
        window.history.replaceState(null, null, newUrl)
        store.commit('SET_NAME', res.data && res.data.nickName)
        store.commit('SET_USERID', res.data && res.data.id)
        store.commit('SET_AVATAR_URL', res.data && res.data.avatarUrl)
        store.commit('SET_LOGIN_STATE', true)
        store.commit('SET_BINDFLAG', res.data && res.data.bindFlag)
        setId(res.data.id)
        // setToken(res.data.token)
        setUserName(res.data.nickName)
        setAvatar(res.data.avatarUrl)
        // 执行之前的操作 登录之后进入观看视频界面
        if (localStorage.getItem('toPath')) {
          var pathInfo = JSON.parse(localStorage.getItem('toPath'))
          // localStorage.removeItem('toPath')
        }
        if (pathInfo && pathInfo.path === '/video') {
          router.push({path: `/video/${pathInfo.id}`})
        } else if (pathInfo) {
          router.push(pathInfo.path)
        }
        // else if (pathInfo.path === '/search') {
        //   router.push({ path: '/search', query: { keyword: pathInfo.keyWord } })
        // }
        // } else if (res.code === 40701) {
        //   store.commit('SET_LOGIN_STATE', false)
        //   store.commit('SET_WECHAT_LOGIN', true)
        // if (store.state.needWechatLogin) {
        //   store.commit('SET_WECHAT_LOGIN', false)
        //   view.$alert('请先在小程序端登录', '提示', {
        //     confirmButtonText: '确定'
        //   })
        // }
        // }
      })
    } else {
      // 显示未登录状态
      // store.commit('SET_LOGIN_STATE', false)
      store.commit('SET_LOGIN_STATE', false)
      return new Promise((resolve, reject) => {
        resolve()
      })
    }
  }
}

export default getPermission



// WEBPACK FOOTER //
// ./src/authentication/permission.js